/*=========================================================================================
  File Name: moduleWarehouseMutations.js
  Description: Warehouse Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {};
